// Centralized API configuration — keep in sync with constants/index.ts
import { resolveApiBaseUrl } from '../lib/apiBaseUrl';
export const API_BASE_URL = resolveApiBaseUrl();

export const API_ENDPOINTS = {
  auth: {
    login: `${API_BASE_URL}/auth/login`,
    register: `${API_BASE_URL}/auth/register`,
    refresh: `${API_BASE_URL}/auth/refresh`,
    switchRole: `${API_BASE_URL}/auth/switch-role`,
  },
  profile: {
    update: `${API_BASE_URL}/profile/update`,
  },
  credits: {
    balance: `${API_BASE_URL}/credits/balance`,
    consume: `${API_BASE_URL}/credits/consume`,
    refund: `${API_BASE_URL}/credits/refund`,
    history: (days: number) => `${API_BASE_URL}/credits/history?days=${days}`,
    analytics: (days: number) => `${API_BASE_URL}/credits/analytics?days=${days}`,
    exportCsv: `${API_BASE_URL}/credits/export/csv`,
    packages: `${API_BASE_URL}/credits/packages`,
    paymentMethods: `${API_BASE_URL}/credits/payment-methods`,
    autoReload: {
      settings: `${API_BASE_URL}/credits/auto-reload/settings`,
      history: `${API_BASE_URL}/credits/auto-reload/history`,
    },
  },
  payments: {
    stripeCheckout: `${API_BASE_URL}/payments/create-checkout-session`,
    pricing: `${API_BASE_URL}/payments/pricing`,
    history: `${API_BASE_URL}/payments/history`,
    subscription: `${API_BASE_URL}/payments/subscription`,
  },
  applications: {
    list: `${API_BASE_URL}/applications`,
    myApplications: `${API_BASE_URL}/applications/my-applications`,
    albania: {
      tourist: `${API_BASE_URL}/visa-applications/albania/tourist/submit`,
    },
  },
  ai: {
    processDocument: `${API_BASE_URL}/ai/process-document`,
  },
  verification: {
    status: `${API_BASE_URL}/verification/status`,
  },
  individual: {
    stats: `${API_BASE_URL}/individual/stats`,
  },
  promoCodes: {
    apply: `${API_BASE_URL}/promo-codes/apply`,
    history: `${API_BASE_URL}/promo-codes/history`,
  },
  corporate: {
    departments: `${API_BASE_URL}/corporate/departments`,
    approvals: `${API_BASE_URL}/corporate/approvals`,
    costCenters: `${API_BASE_URL}/corporate/cost-centers`,
  },
  enterprise: {
    apiKeys: `${API_BASE_URL}/enterprise/api-keys`,
    pricingRequests: `${API_BASE_URL}/enterprise/pricing-requests`,
    invoices: `${API_BASE_URL}/enterprise/invoices`,
    branding: `${API_BASE_URL}/enterprise/branding`,
  },
  agent: {
    clientCredits: `${API_BASE_URL}/agent/client-credits`,
    commissions: `${API_BASE_URL}/agent/commissions`,
    allocateCredits: `${API_BASE_URL}/agent/allocate-credits`,
  },
  countries: `${API_BASE_URL}/countries`,
  countryDetails: {
    complete: (iso2: string) => `${API_BASE_URL}/countries/${iso2}/complete`,
    sources: (iso2: string) => `${API_BASE_URL}/countries/${iso2}/sources`,
  },
  stats: {
    global: `${API_BASE_URL}/stats`,
  },
  visa: {
    byCountry: (iso2: string) => `${API_BASE_URL}/visa-types?countryCode=${iso2}`,
    details: (id: number | string) => `${API_BASE_URL}/visa-types/${id}`,
    full: (id: number | string) => `${API_BASE_URL}/visa-types/${id}/full`,
    search: `${API_BASE_URL}/visa-types/search`,
    categories: `${API_BASE_URL}/visa-types/categories`,
    compare: `${API_BASE_URL}/visa/compare`,
  },
  chat: {
    messages: `${API_BASE_URL}/chat/messages`,
    send: `${API_BASE_URL}/chat/send`,
  },
  consultation: {
    slots: `${API_BASE_URL}/consultation/slots`,
    book: `${API_BASE_URL}/consultation/book`,
  },
  travel: {
    search: `${API_BASE_URL}/travel/search`,
    itineraries: `${API_BASE_URL}/travel/itineraries`,
  },
  support: {
    tickets: `${API_BASE_URL}/support/tickets`,
    contact: `${API_BASE_URL}/support/contact`,
  },
  savedApplications: `${API_BASE_URL}/saved-applications`,
  communications: {
    send: `${API_BASE_URL}/communications/send`,
    list: `${API_BASE_URL}/communications/list`,
  },
  notifications: `${API_BASE_URL}/notifications`,
  dashboard: {
    individual: `${API_BASE_URL}/dashboard/individual`,
    corporate: `${API_BASE_URL}/dashboard/corporate`,
    admin: `${API_BASE_URL}/dashboard/admin`,
    agent: `${API_BASE_URL}/dashboard/agent`,
    enterprise: `${API_BASE_URL}/dashboard/enterprise`,
  },
};
